(() => {
  const root = document.querySelector('[data-geurmaatje]');
  if (!root) return;

  const launcher = root.querySelector('.geurmaatje__launcher');
  const invitation = root.querySelector('.geurmaatje__invitation');
  const panel = root.querySelector('.geurmaatje__panel');
  const close = root.querySelector('.geurmaatje__close');
  const messages = root.querySelector('.geurmaatje__messages');
  const prompts = root.querySelector('.geurmaatje__prompts');
  const form = root.querySelector('.geurmaatje__form');
  const input = root.querySelector('input[name="message"]');
  const submit = form.querySelector('button[type="submit"]');
  const SESSION_KEY = 'geurmaatje-session-v1';
  const MAX_HISTORY_MESSAGES = 12;
  const history = [];
  const transcript = [];
  let genderChoices;
  let pendingGenderChoice = false;

  const normalizeMessageRole = (role) => role === 'user' ? 'visitor' : role;

  const trimHistory = () => {
    if (history.length > MAX_HISTORY_MESSAGES) history.splice(0, history.length - MAX_HISTORY_MESSAGES);
  };

  const focusInputIfDesktop = () => {
    if (window.matchMedia('(min-width: 480px)').matches) input.focus();
  };

  const hideInvitation = () => {
    invitation.hidden = true;
  };

  const showInvitation = () => {
    if (panel.hidden) invitation.hidden = false;
  };

  const saveSession = () => {
    try {
      window.sessionStorage.setItem(SESSION_KEY, JSON.stringify({
        open: !panel.hidden,
        history,
        transcript,
        pendingGenderChoice,
      }));
    } catch {}
  };

  const addMessage = (content, role, persist = true) => {
    const item = document.createElement('div');
    item.className = `geurmaatje__message geurmaatje__message--${role}`;
    item.textContent = content;
    messages.append(item);
    messages.scrollTop = messages.scrollHeight;
    if (persist) {
      transcript.push({ type: 'message', content, role });
      saveSession();
    }
  };

  const addRecommendationSummary = (content, persist = true) => {
    const item = document.createElement('div');
    item.className = 'geurmaatje__message geurmaatje__message--assistant geurmaatje__recommendation-summary';
    content.split('\n').filter(Boolean).forEach((line) => {
      const entry = document.createElement('p');
      const separator = line.indexOf(':');
      const name = document.createElement('strong');
      name.textContent = separator === -1 ? line : line.slice(0, separator);
      entry.append(name);
      if (separator !== -1) entry.append(document.createTextNode(line.slice(separator)));
      item.append(entry);
    });
    messages.append(item);
    messages.scrollTop = messages.scrollHeight;
    if (persist) {
      transcript.push({ type: 'recommendation', content });
      saveSession();
    }
  };

  const addGenderChoices = (persist = true) => {
    genderChoices?.remove();
    genderChoices = document.createElement('div');
    genderChoices.className = 'geurmaatje__gender-choices';
    ['Heren', 'Dames'].forEach((label) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = label;
      button.addEventListener('click', () => {
        genderChoices.remove();
        genderChoices = null;
        pendingGenderChoice = false;
        saveSession();
        ask(`Voor ${label.toLocaleLowerCase('nl-NL')}.`);
      });
      genderChoices.append(button);
    });
    messages.append(genderChoices);
    messages.scrollTop = messages.scrollHeight;
    if (persist) {
      pendingGenderChoice = true;
      saveSession();
    }
  };

  const addProduct = (product, persist = true) => {
    const card = document.createElement('article');
    card.className = 'geurmaatje__card';
    card.setAttribute('role', 'link');
    card.tabIndex = 0;
    const goToProduct = () => {
      window.location.assign(product.url);
    };
    card.addEventListener('click', () => {
      goToProduct();
    });
    card.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      goToProduct();
    });
    if (product.imageUrl) {
      const image = document.createElement('img');
      image.src = product.imageUrl;
      image.alt = product.title;
      card.append(image);
    }
    const body = document.createElement('div');
    const title = document.createElement('h3');
    title.textContent = product.title;
    body.append(title);
    if (product.inspiredBy) {
      const inspiredBy = document.createElement('p');
      inspiredBy.className = 'geurmaatje__inspired-by';
      inspiredBy.textContent = `Geïnspireerd door: ${product.inspiredBy}`;
      body.append(inspiredBy);
    }
    if (product.notes?.length) {
      const notes = document.createElement('p');
      notes.className = 'geurmaatje__notes';
      notes.textContent = `Noten: ${product.notes.join(', ')}`;
      body.append(notes);
    }
    card.append(body);
    messages.append(card);
    messages.scrollTop = messages.scrollHeight;
    if (persist) {
      transcript.push({ type: 'product', product });
      saveSession();
    }
  };

  const addTyping = () => {
    const item = document.createElement('div');
    item.className = 'geurmaatje__message geurmaatje__message--assistant geurmaatje__typing';
    item.setAttribute('aria-label', 'Geurmaatje typt');
    item.innerHTML = '<span></span><span></span><span></span>';
    messages.append(item);
    messages.scrollTop = messages.scrollHeight;
    return item;
  };

  const restoreSession = () => {
    try {
      const session = JSON.parse(window.sessionStorage.getItem(SESSION_KEY) || 'null');
      if (!session || !Array.isArray(session.history)) return;
      session.history
        .filter((message) => (message.role === 'user' || message.role === 'assistant') && typeof message.content === 'string')
        .forEach((message) => history.push(message));
      if (Array.isArray(session.transcript) && session.transcript.length) {
        session.transcript.forEach((entry) => {
          if (entry.type === 'message' && typeof entry.content === 'string') addMessage(entry.content, normalizeMessageRole(entry.role), false);
          if (entry.type === 'recommendation' && typeof entry.content === 'string') addRecommendationSummary(entry.content, false);
          if (entry.type === 'product' && entry.product && typeof entry.product === 'object') addProduct(entry.product, false);
        });
      } else {
        history.forEach((message) => {
          const role = normalizeMessageRole(message.role);
          transcript.push({ type: 'message', content: message.content, role });
          addMessage(message.content, role, false);
        });
      }
      trimHistory();
      if (session.pendingGenderChoice) {
        pendingGenderChoice = true;
        addGenderChoices(false);
      }
      saveSession();
      if (!session.open) return;
      panel.hidden = false;
      launcher.hidden = true;
      launcher.setAttribute('aria-expanded', 'true');
    } catch {}
  };

  const open = () => {
    hideInvitation();
    panel.hidden = false;
    launcher.hidden = true;
    launcher.setAttribute('aria-expanded', 'true');
    saveSession();
    focusInputIfDesktop();
  };

  const shut = () => {
    panel.hidden = true;
    launcher.hidden = false;
    launcher.setAttribute('aria-expanded', 'false');
    saveSession();
    launcher.focus();
  };

  const ask = async (question) => {
    const content = question.trim();
    if (!content || submit.disabled) return;
    if (genderChoices) {
      genderChoices.remove();
      genderChoices = null;
      pendingGenderChoice = false;
    }
    open();
    addMessage(content, 'visitor');
    history.push({ role: 'user', content });
    trimHistory();
    saveSession();
    prompts.hidden = true;
    input.value = '';
    submit.disabled = true;
    const typing = addTyping();
    try {
      const response = await fetch(root.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: history }),
      });
      const reply = await response.json();
      if (!response.ok) throw new Error(reply.error || 'Er ging iets mis.');
      if (reply.recommendationSummary) addRecommendationSummary(reply.message);
      else addMessage(reply.message, 'assistant');
      history.push({ role: 'assistant', content: reply.message });
      trimHistory();
      saveSession();
      if (reply.genderChoiceRequired) addGenderChoices();
      (reply.products || []).forEach(addProduct);
    } catch (error) {
      addMessage(error.message || 'Sorry, probeer het zo nog eens.', 'assistant');
    } finally {
      typing.remove();
      submit.disabled = false;
      focusInputIfDesktop();
    }
  };

  launcher.addEventListener('click', () => (panel.hidden ? open() : shut()));
  close.addEventListener('click', shut);
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    ask(input.value);
  });
  root.querySelectorAll('.geurmaatje__prompts button').forEach((button) => {
    button.addEventListener('click', () => ask(button.textContent || ''));
  });
  restoreSession();
  setTimeout(showInvitation, 5000);
})();
